import trace from '../lib/trace';
import config from '~/configuration';
import auth from '~/lib/authentication';

const getQLResponse = async (url, options) => {
  const headers = {
    ...config.apiHeaders(),
    'Content-Type': 'application/json',
  };

  for (let entry in options?.headers ?? {}) {
    headers[entry.toLowerCase()] = options.headers[entry];
  }

  const token = await auth.getAutoRefreshAccessToken();

  if (token === null) {
    throw new Error('No access token available');
  }

  headers['authorization'] = `Bearer ${token}`;

  return fetch(url, {
    ...(options ?? {}),
    headers,
  });
};

const fetchHandler = async (url, options) => {
  if (url.indexOf(config.api) === 0) {
    return await getQLResponse(url, options);
  }

  return await fetch(url, options);
};

const wrappedFetch = async (url, options) => {
  const start = Date.now();
  const result = await fetchHandler(url, options);
  const diff = Date.now() - start;
  trace(url, result.status, `${diff}ms`);

  return result;
};

export {wrappedFetch as fetch};

export const throttled = (func) => {
  let pending;
  return async (...args) => {
    pending?.abort('Pending call canceled');

    pending = new AbortController();
    const signal = pending.signal;
    try {
      await new Promise((resolve) => setTimeout(resolve, 250));
      if (signal.aborted) {
        return;
      }

      return await func(signal, ...args);
    } finally {
      if (signal.aborted) {
        return;
      }

      pending = null;
    }
  };
};
